import _export from "../internals/export";
import _globalThis2 from "../internals/global-this";
import _anInstance from "../internals/an-instance";
import _anObject from "../internals/an-object";
import _isCallable from "../internals/is-callable";
import _objectGetPrototypeOf from "../internals/object-get-prototype-of";
import _defineBuiltInAccessor from "../internals/define-built-in-accessor";
import _createProperty from "../internals/create-property";
import _fails from "../internals/fails";
import _hasOwnProperty from "../internals/has-own-property";
import _wellKnownSymbol from "../internals/well-known-symbol";
import _iteratorsCore from "../internals/iterators-core";
import _descriptors from "../internals/descriptors";
import _isPure from "../internals/is-pure";
var $ = _export;
var _globalThis = _globalThis2;
var anInstance = _anInstance;
var anObject = _anObject;
var isCallable = _isCallable;
var getPrototypeOf = _objectGetPrototypeOf;
var defineBuiltInAccessor = _defineBuiltInAccessor;
var createProperty = _createProperty;
var fails = _fails;
var hasOwn = _hasOwnProperty;
var wellKnownSymbol = _wellKnownSymbol;
var IteratorPrototype = _iteratorsCore.IteratorPrototype;
var DESCRIPTORS = _descriptors;
var IS_PURE = _isPure;
var CONSTRUCTOR = "constructor";
var ITERATOR = "Iterator";
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var $TypeError = TypeError;
var NativeIterator = _globalThis[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED = IS_PURE || !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype
// FF44- non-standard `Iterator` passes previous tests
|| !fails(function () {
  NativeIterator({});
});
var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype);
  if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError("Abstract class Iterator not directly constructable");
};
var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject(this);
        if (this === IteratorPrototype) throw new $TypeError("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype[key] = value;
};
if (!hasOwn(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);
if (FORCED || !hasOwn(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}
IteratorConstructor.prototype = IteratorPrototype;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$({
  global: true,
  constructor: true,
  forced: FORCED
}, {
  Iterator: IteratorConstructor
});
export default {};